import { FilterFlowSecAdapter } from "./filter.flowsec.adapter";
import { UserAdapterMapper } from "./mapper/user.adapter.mapper";
import { QueryExpressionParserService } from "@nrwl/query-emitter";

export class FilterUserAdapter extends FilterFlowSecAdapter {
  constructor(queryBuilder: QueryExpressionParserService, config) {
    super(queryBuilder, config);
  }

  populateIncoming() {
    UserAdapterMapper.populateIncoming(this.keywordsToIncoming);
  }

  populateOutgoing() {
    UserAdapterMapper.populateOutgoing(this.keywordsToOutgoing);
  }
}
